(function () {
  "use strict";

  if (customElements.get("product-additional-images")) return;

  class ProductAdditionalImages extends HTMLElement {
    constructor() {
      super();

      this.items = [];
      this.images = [];
      this.currentIndex = 0;
      this.modal = null;

      this.bodyClass = "product-additional-images-modal-opened";

      /* Touch / swipe */
      this.touchStartX = 0;
      this.touchStartY = 0;

      /* Pinch zoom */
      this.initialPinchDistance = 0;
      this.pinchStartScale = 1;
      this.currentScale = 1;
      this.isPinching = false;

      /* Pan / drag */
      this.translateX = 0;
      this.translateY = 0;

      this.panStartX = 0;
      this.panStartY = 0;

      this.panStartTranslateX = 0;
      this.panStartTranslateY = 0;

      this.isPanning = false;
      this.hasPanned = false;

      /* Desktop swipe */
      this.pointerStartX = 0;
      this.pointerStartY = 0;
      this.isPointerDown = false;

      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(
        this.querySelectorAll(".product-additional-images__item")
      );

      this.images = this.items.map((item) => ({
        src: item.dataset.fullSrc,
        alt: item.dataset.alt || this.dataset.productTitle || ""
      }));

      this.items.forEach((item, index) => {
        item.addEventListener("click", () => this.open(index));
      });
    }

    open(index) {
      if (!this.images.length) return;

      this.currentIndex = index;

      this.buildModal();
      this.updateModalImage();

      document.body.classList.add(this.bodyClass);
      document.addEventListener("keydown", this.handleKeydown);
    }

    buildModal() {
      this.close();

      this.modal = document.createElement("div");
      this.modal.className = "product-additional-images-modal";

      this.modal.innerHTML = `
        <div
          class="product-additional-images-modal__content"
          role="dialog"
          aria-modal="true"
        >
          <div class="product-additional-images-modal__counter"></div>

          <button
            type="button"
            class="product-additional-images-modal__close"
            aria-label="Close"
          >
            <span>×</span>
          </button>

          <button
            type="button"
            class="product-additional-images-modal__nav product-additional-images-modal__nav--prev"
            aria-label="Previous image"
          >
            <span class="product-additional-images-modal__nav-icon">‹</span>
          </button>

          <div class="product-additional-images-modal__viewport">
            <img
              class="product-additional-images-modal__img"
              alt=""
              draggable="false"
            >
          </div>

          <button
            type="button"
            class="product-additional-images-modal__nav product-additional-images-modal__nav--next"
            aria-label="Next image"
          >
            <span class="product-additional-images-modal__nav-icon">›</span>
          </button>
        </div>
      `;

      const viewport = this.modal.querySelector(
        ".product-additional-images-modal__viewport"
      );

      const img = this.modal.querySelector(
        ".product-additional-images-modal__img"
      );

      const closeBtn = this.modal.querySelector(
        ".product-additional-images-modal__close"
      );

      const prevBtn = this.modal.querySelector(
        ".product-additional-images-modal__nav--prev"
      );

      const nextBtn = this.modal.querySelector(
        ".product-additional-images-modal__nav--next"
      );

      /* =========================
         CLOSE / NAVIGATION
      ========================== */

      this.modal.addEventListener("click", (event) => {
        if (event.target === this.modal) {
          this.close();
        }
      });

      closeBtn.addEventListener("click", (event) => {
        event.stopPropagation();
        this.close();
      });

      const isRTL =
        document.documentElement.dir === "rtl";

      prevBtn.addEventListener("click", (event) => {
        event.stopPropagation();

        if (isRTL) {
          this.navigate(1);
        } else {
          this.navigate(-1);
        }
      });

      nextBtn.addEventListener("click", (event) => {
        event.stopPropagation();

        if (isRTL) {
          this.navigate(-1);
        } else {
          this.navigate(1);
        }
      });

      /* =========================
         CLICK TO ZOOM
      ========================== */

      img.addEventListener("click", (event) => {
        event.stopPropagation();

        /*
         * لو المستخدم كان بيسحب الصورة
         * لا نحسب نهاية السحب Click.
         */
        if (this.hasPanned) {
          this.hasPanned = false;
          return;
        }

        this.toggleZoom();
      });

      /* ==========================================
         DESKTOP:
         - NORMAL IMAGE = SWIPE BETWEEN IMAGES
         - ZOOMED IMAGE = PAN INSIDE IMAGE
      =========================================== */

      viewport.addEventListener("pointerdown", (event) => {
        if (event.pointerType !== "mouse") return;
        if (event.button !== 0) return;

        this.isPointerDown = true;
        this.hasPanned = false;

        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;

        /*
         * الصورة مكبرة:
         * Drag = Pan داخل الصورة.
         */
        if (this.currentScale > 1.05) {
          event.preventDefault();

          this.isPanning = true;

          this.panStartX = event.clientX;
          this.panStartY = event.clientY;

          this.panStartTranslateX = this.translateX;
          this.panStartTranslateY = this.translateY;

          img.classList.add("is-panning");

          /*
           * Pointer capture مطلوب فقط أثناء Pan
           * حتى يستمر السحب بسلاسة خارج حدود الصورة.
           */
          try {
            viewport.setPointerCapture(event.pointerId);
          } catch (e) {
            /* Ignore unsupported pointer capture */
          }

        } else {
          /*
           * الصورة غير مكبرة:
           * لا نستخدم Pointer Capture هنا
           * حتى يظل Click على الصورة يعمل للـ Zoom.
           *
           * Drag أفقي واضح سيظل يستخدم للتنقل بين الصور.
           */
          this.isPanning = false;
        }
      });

      viewport.addEventListener("pointermove", (event) => {
        if (event.pointerType !== "mouse") return;
        if (!this.isPointerDown) return;

        const totalDeltaX =
          event.clientX - this.pointerStartX;

        const totalDeltaY =
          event.clientY - this.pointerStartY;

        /*
         * بمجرد ما يحصل Drag واضح،
         * نمنع click-to-zoom بعد الإفلات.
         */
        if (
          Math.abs(totalDeltaX) > 5 ||
          Math.abs(totalDeltaY) > 5
        ) {
          this.hasPanned = true;
        }

        /*
         * PAN فقط لو الصورة مكبرة.
         */
        if (
          this.currentScale > 1.05 &&
          this.isPanning
        ) {
          event.preventDefault();

          const deltaX =
            event.clientX - this.panStartX;

          const deltaY =
            event.clientY - this.panStartY;

          this.translateX =
            this.panStartTranslateX + deltaX;

          this.translateY =
            this.panStartTranslateY + deltaY;

          this.constrainPan(img, viewport);
          this.applyTransform(img);
        }
      });

      const finishPointerInteraction = (event) => {
        if (event.pointerType !== "mouse") return;
        if (!this.isPointerDown) return;

        const deltaX =
          event.clientX - this.pointerStartX;

        const deltaY =
          event.clientY - this.pointerStartY;

        const wasZoomed =
          this.currentScale > 1.05;

        this.isPointerDown = false;

        /*
         * لو الصورة مكبرة:
         * - Drag = ننهي الـ Pan فقط.
         * - Click ثابت بدون سحب = Zoom Out.
         */
        if (wasZoomed) {
          this.isPanning = false;
          img.classList.remove("is-panning");

          try {
            if (viewport.hasPointerCapture(event.pointerId)) {
              viewport.releasePointerCapture(event.pointerId);
            }
          } catch (e) {
            /* Ignore unsupported pointer capture */
          }

          if (!this.hasPanned) {
            this.toggleZoom();
          }

          return;
        }

        /*
         * الصورة غير مكبرة:
         * Horizontal drag = next / previous image.
         */
        if (
          Math.abs(deltaX) > 50 &&
          Math.abs(deltaX) > Math.abs(deltaY)
        ) {
          this.navigateBySwipe(deltaX);
        }

        try {
          if (viewport.hasPointerCapture(event.pointerId)) {
            viewport.releasePointerCapture(event.pointerId);
          }
        } catch (e) {
          /* Ignore unsupported pointer capture */
        }
      };

      viewport.addEventListener(
        "pointerup",
        finishPointerInteraction
      );

      viewport.addEventListener(
        "pointercancel",
        finishPointerInteraction
      );

      /* =====================================
         MOBILE TOUCH / PINCH / PAN / SWIPE
      ====================================== */

      viewport.addEventListener(
        "touchstart",
        (event) => {

          /* One finger */
          if (event.touches.length === 1) {
            this.touchStartX =
              event.touches[0].clientX;

            this.touchStartY =
              event.touches[0].clientY;

            this.isPinching = false;
            this.hasPanned = false;

            /*
             * لو الصورة مكبرة:
             * إصبع واحد = Pan.
             */
            if (this.currentScale > 1.05) {
              this.isPanning = true;

              this.panStartTranslateX =
                this.translateX;

              this.panStartTranslateY =
                this.translateY;

              img.classList.add("is-panning");
            } else {
              /*
               * الصورة غير مكبرة:
               * إصبع واحد = Swipe للتنقل.
               */
              this.isPanning = false;
            }
          }

          /* Two fingers = Pinch zoom */
          if (event.touches.length === 2) {
            this.isPinching = true;
            this.isPanning = false;
            this.hasPanned = true;

            this.initialPinchDistance =
              this.getPinchDistance(event.touches);

            this.pinchStartScale =
              this.currentScale;

            img.classList.remove("is-panning");
            img.classList.add("is-pinching");
          }
        },
        { passive: true }
      );

      viewport.addEventListener(
        "touchmove",
        (event) => {

          /* =================
             PINCH ZOOM
          ================== */

          if (event.touches.length === 2) {
            event.preventDefault();

            const distance =
              this.getPinchDistance(event.touches);

            const scaleRatio =
              distance / this.initialPinchDistance;

            this.currentScale =
              this.pinchStartScale * scaleRatio;

            this.currentScale = Math.min(
              Math.max(this.currentScale, 1),
              3
            );

            if (this.currentScale <= 1.05) {
              this.translateX = 0;
              this.translateY = 0;
            }

            this.constrainPan(img, viewport);
            this.applyTransform(img);

            return;
          }

          /* =================
             ONE FINGER PAN
          ================== */

          if (
            event.touches.length === 1 &&
            this.currentScale > 1.05 &&
            this.isPanning
          ) {
            event.preventDefault();

            const deltaX =
              event.touches[0].clientX -
              this.touchStartX;

            const deltaY =
              event.touches[0].clientY -
              this.touchStartY;

            if (
              Math.abs(deltaX) > 3 ||
              Math.abs(deltaY) > 3
            ) {
              this.hasPanned = true;
            }

            this.translateX =
              this.panStartTranslateX + deltaX;

            this.translateY =
              this.panStartTranslateY + deltaY;

            this.constrainPan(img, viewport);
            this.applyTransform(img);
          }
        },
        { passive: false }
      );

      viewport.addEventListener(
        "touchend",
        (event) => {

          /* =================
             FINISH PINCH
          ================== */

          if (this.isPinching) {
            if (event.touches.length < 2) {
              this.isPinching = false;

              img.classList.remove("is-pinching");

              if (this.currentScale <= 1.05) {
                this.currentScale = 1;
                this.translateX = 0;
                this.translateY = 0;

                this.applyTransform(img);
              }
            }

            return;
          }

          /* =================
             FINISH PAN
          ================== */

          if (this.currentScale > 1.05) {
            this.isPanning = false;
            img.classList.remove("is-panning");
            return;
          }

          this.isPanning = false;

          /* =================
             NORMAL SWIPE
          ================== */

          const touch =
            event.changedTouches[0];

          if (!touch) return;

          const deltaX =
            touch.clientX - this.touchStartX;

          const deltaY =
            touch.clientY - this.touchStartY;

          if (
            Math.abs(deltaX) > 50 &&
            Math.abs(deltaX) > Math.abs(deltaY)
          ) {
            /*
             * منع click-to-zoom بعد السحب.
             */
            this.hasPanned = true;

            this.navigateBySwipe(deltaX);
          }
        },
        { passive: true }
      );

      /* Hide arrows if only one image */
      if (this.images.length <= 1) {
        prevBtn.style.display = "none";
        nextBtn.style.display = "none";
      }

      document.body.appendChild(this.modal);
    }

    /* =====================================
       RTL / LTR SWIPE LOGIC
    ====================================== */

    navigateBySwipe(deltaX) {
      const isRTL =
        document.documentElement.dir === "rtl";

      /*
       * ARABIC / RTL
       *
       * Left → Right = NEXT
       * Right → Left = PREVIOUS
       */
      if (isRTL) {
        if (deltaX > 0) {
          this.navigate(1);
        } else {
          this.navigate(-1);
        }

        return;
      }

      /*
       * ENGLISH / LTR
       *
       * Right → Left = NEXT
       * Left → Right = PREVIOUS
       */
      if (deltaX < 0) {
        this.navigate(1);
      } else {
        this.navigate(-1);
      }
    }

    /* =====================================
       UPDATE IMAGE
    ====================================== */

    updateModalImage() {
      if (
        !this.modal ||
        !this.images[this.currentIndex]
      ) {
        return;
      }

      const image =
        this.images[this.currentIndex];

      const img = this.modal.querySelector(
        ".product-additional-images-modal__img"
      );

      const counter = this.modal.querySelector(
        ".product-additional-images-modal__counter"
      );

      /*
       * Reset zoom and pan
       * whenever changing image.
       */
      this.currentScale = 1;

      this.translateX = 0;
      this.translateY = 0;

      this.isPanning = false;
      this.isPinching = false;
      this.isPointerDown = false;
      this.hasPanned = false;

      img.classList.remove(
        "is-zoomed",
        "is-panning",
        "is-pinching"
      );

      this.applyTransform(img);

      img.src = image.src;
      img.alt = image.alt;

      counter.textContent =
        `${this.currentIndex + 1} / ${this.images.length}`;
    }

    /* =====================================
       NEXT / PREVIOUS
    ====================================== */

    navigate(direction) {
      if (this.images.length <= 1) return;

      this.currentIndex =
        (
          this.currentIndex +
          direction +
          this.images.length
        ) % this.images.length;

      this.updateModalImage();
    }

    /* =====================================
       CLICK ZOOM
    ====================================== */

    toggleZoom() {
      if (!this.modal) return;

      const img = this.modal.querySelector(
        ".product-additional-images-modal__img"
      );

      const viewport = this.modal.querySelector(
        ".product-additional-images-modal__viewport"
      );

      /* Zoom OUT */
      if (this.currentScale > 1.05) {
        this.currentScale = 1;

        this.translateX = 0;
        this.translateY = 0;

        this.applyTransform(img);

        return;
      }

      /* Zoom IN */
      this.currentScale = 1.8;

      this.translateX = 0;
      this.translateY = 0;

      this.constrainPan(img, viewport);
      this.applyTransform(img);
    }

    /* =====================================
       APPLY ZOOM + PAN
    ====================================== */

    applyTransform(img) {
      if (!img) return;

      img.style.transform = `
        matrix(
          ${this.currentScale},
          0,
          0,
          ${this.currentScale},
          ${this.translateX},
          ${this.translateY}
        )
      `;

      img.classList.toggle(
        "is-zoomed",
        this.currentScale > 1.05
      );
    }

    /* =====================================
       KEEP PAN WITHIN IMAGE
    ====================================== */

    constrainPan(img, viewport) {
      if (!img || !viewport) return;

      if (this.currentScale <= 1) {
        this.translateX = 0;
        this.translateY = 0;
        return;
      }

      const baseWidth =
        img.offsetWidth;

      const baseHeight =
        img.offsetHeight;

      const viewportWidth =
        viewport.clientWidth;

      const viewportHeight =
        viewport.clientHeight;

      const scaledWidth =
        baseWidth * this.currentScale;

      const scaledHeight =
        baseHeight * this.currentScale;

      const maxX = Math.max(
        0,
        (scaledWidth - viewportWidth) / 2
      );

      const maxY = Math.max(
        0,
        (scaledHeight - viewportHeight) / 2
      );

      this.translateX = Math.max(
        -maxX,
        Math.min(maxX, this.translateX)
      );

      this.translateY = Math.max(
        -maxY,
        Math.min(maxY, this.translateY)
      );
    }

    /* =====================================
       PINCH DISTANCE
    ====================================== */

    getPinchDistance(touches) {
      const dx =
        touches[0].clientX -
        touches[1].clientX;

      const dy =
        touches[0].clientY -
        touches[1].clientY;

      return Math.sqrt(
        dx * dx + dy * dy
      );
    }

    /* =====================================
       KEYBOARD
    ====================================== */

    handleKeydown(event) {
      if (event.key === "Escape") {
        this.close();
        return;
      }

      const isRTL =
        document.documentElement.dir === "rtl";

      if (event.key === "ArrowLeft") {
        this.navigate(isRTL ? 1 : -1);
      }

      if (event.key === "ArrowRight") {
        this.navigate(isRTL ? -1 : 1);
      }
    }

    /* =====================================
       CLOSE
    ====================================== */

    close() {
      if (this.modal) {
        this.modal.remove();
        this.modal = null;
      }

      this.currentScale = 1;

      this.translateX = 0;
      this.translateY = 0;

      this.isPanning = false;
      this.isPinching = false;
      this.isPointerDown = false;
      this.hasPanned = false;

      document.body.classList.remove(
        this.bodyClass
      );

      document.removeEventListener(
        "keydown",
        this.handleKeydown
      );
    }
  }

  customElements.define(
    "product-additional-images",
    ProductAdditionalImages
  );
})();